import { useState, type SyntheticEvent } from 'react'
import type { NewsItem } from '../../types/news'
import { isUsableNewsImage } from '../../services/news/presentation'
import { CategoryBadge } from './CategoryBadge'
import { CategoryFallbackArtwork } from './CategoryFallbackArtwork'
import { shouldUseNewsSourceImage } from './newsCuration'

export function NewsCardMedia({ item, featured = false }: { item: NewsItem; featured?: boolean }) {
  const [rejectedImageUrl, setRejectedImageUrl] = useState<string | null>(null)
  const primaryCategory = item.categories[0]
  const sourceArtEligible = shouldUseNewsSourceImage(item)
  const sourceArtFallback = Boolean(item.imageUrl && !sourceArtEligible)
  const showImage = Boolean(sourceArtEligible && item.imageUrl && rejectedImageUrl !== item.imageUrl)

  const validateImage = (event: SyntheticEvent<HTMLImageElement>) => {
    const image = event.currentTarget
    if (!isUsableNewsImage(image.naturalWidth, image.naturalHeight)) setRejectedImageUrl(item.imageUrl ?? null)
  }

  return <div className={`news-card-media ${showImage ? 'has-rss-image' : 'has-fallback-art'} ${sourceArtFallback ? 'has-source-art-fallback' : ''}`} data-media-treatment={showImage ? 'source-image' : sourceArtFallback ? 'source-art-fallback' : 'category-art'}>
    {showImage
      ? <img src={item.imageUrl} alt={`Source image for “${item.title}”`} loading={featured ? 'eager' : 'lazy'} decoding="async" referrerPolicy="no-referrer" onLoad={validateImage} onError={() => setRejectedImageUrl(item.imageUrl ?? null)}/>
      : <CategoryFallbackArtwork category={primaryCategory} storyId={item.id} priority={featured}/>
    }
    <CategoryBadge category={primaryCategory}/>
  </div>
}
